import { render } from "./StudentIdCards.vue?vue&type=template&id=5a85a0e2&scoped=true"
import script from "./StudentIdCards.vue?vue&type=script&lang=js"
export * from "./StudentIdCards.vue?vue&type=script&lang=js"

import "./StudentIdCards.vue?vue&type=style&index=0&id=5a85a0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a85a0e2"]])

export default __exports__